import withLoader from "UIComponents/GqlWithLoader";
import comp from "./ResourceList";
export default withLoader(comp);
